import { gql } from '@apollo/client';

export const FETCH_FUNDS = gql`
  query fetchFunds($order: FundOrder, $first: Int) {
    funds(order: $order, first: $first) {
      nodes {
        id
        name
        shortName
        symbol
        category
        currency
        date
        bid
        ask
        cumulativeReturns {
          oneMonthReturn
          threeMonthReturn
          sixMonthReturn
          oneYearReturn
          threeYearReturn
          fiveYearReturn
          yearToDateReturn
        }
        annualizedReturns {
          oneYearReturn
          twoYearReturn
          threeYearReturn
          fourYearReturn
          fiveYearReturn
        }
        nominalReturns {
          year
          return
        }
        details {
          riskRating
          onlineBuyAllowed
          onlineSellAllowed
          ucitsClassification
        }
      }
    }
  }
`;
